// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { useEffect, useRef } from 'react';
import {
  getCurrentSymbol,
  calculatePrice,
  PriceDisplay,
  addUTMToURL,
  getDiscountLabel,
} from '../../../Helpers/Helpers';
import { UseWindowDimensions } from '../../collage/utils';
import { useDisplayWidgetContext } from '../../DisplayWidget/utils/context';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import SpecialProductMobileOverlay from './SpecialProductMobileOverlay';
import LazyImage from '../../LazyImage';
import { FiExternalLink } from 'react-icons/fi';
import PostRating from '../../PostRating';
import { CLICK_EVENTS } from '../../../contants';

const shopifyProductExistCache = new Map<string, boolean>();

const checkShopifyProductExists = async (handle?: string) => {
  if (!handle) return true;

  const url = `https://${window.location.host}/products/${handle}.js`;

  if (shopifyProductExistCache.has(url)) {
    return shopifyProductExistCache.get(url);
  }

  try {
    const res = await fetch(url, { method: 'GET' });

    const exists = res.status !== 404;
    shopifyProductExistCache.set(url, exists);

    return exists;
  } catch (err) {
    return true;
  }
};

export default function ProductsOverlay(props) {
  const { row, shopifyData, albumData, activeIndex } = props;
  const btnOneRef = useRef([]);
  const btnTwoRef = useRef([]);
  const [availableProducts, setAvailableProducts] = React.useState(row?.products || []);

  useEffect(() => {
    let mounted = true;

    const validateProducts = async () => {
      if (!row?.products?.length) return;

      const checks = await Promise.all(
        row.products.map((product) => {
          if (!product?.handle) return true;

          return checkShopifyProductExists(product.handle);
        }),
      );

      if (!mounted) return;

      const filtered = row.products.filter((_, i) => checks[i]);
      setAvailableProducts(filtered);
    };

    validateProducts();

    return () => {
      mounted = false;
    };
  }, [row?.products]);

  useEffect(() => {
    if (row?.products?.length > 0) {
      row.products.forEach((_, index) => {
        if (!btnOneRef.current[index]) {
          btnOneRef.current[index] = React.createRef();
        }
        if (!btnTwoRef.current[index]) {
          btnTwoRef.current[index] = React.createRef();
        }
      });
    }
  }, [row?.products]);

  const {
    data,
    setProductOverlayIndex,
    isWooCommerceSite,
    layout,
    isOpen,
    clickMutate,
    showModal,
    setAlbumId,
    selectedProduct,
    setSelectedProduct,
    handleAddCart,
    isShopify,
  } = useDisplayWidgetContext();

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const { width } = UseWindowDimensions();

  useEffect(() => {
    if (!isOpen) {
      setSelectedProduct(null);
    }
  }, [isOpen]);

  return (
    <React.Fragment>
      <style>
        {`.zid_overlay_container .swiper {
            max-width: 100%;
        }
        .zid_overlay_container .swiper-slide {
            height: auto!important;
        }
        `}
      </style>
      <idk-div class="zid_overlay_container zid-absolute zid-left-0 zid-bottom-0 zid-w-full zid-p-0 zid-border zid-border-transparent">
        <Swiper
          modules={[Autoplay]}
          autoplay={true}
          centeredSlides={true}
          slidesPerView={1}
          loop={availableProducts.length > 1}
          pagination={false}
        >
          {availableProducts.length > 0 &&
            availableProducts.map((product, index) => {
              if (!btnOneRef.current[index]) {
                btnOneRef.current[index] = React.createRef();
              }
              if (!btnTwoRef.current[index]) {
                btnTwoRef.current[index] = React.createRef();
              }
              return (
                <SwiperSlide key={index}>
                  {layout?.productsSettings?.productOverlayStyle == 2 ? (
                    <idk-div
                      class="idk_prdct_overlay_main zid-p-[5px]"
                      onClick={() => {
                        showModal(row, 'slider');
                        setAlbumId(row.id);
                        setSelectedProduct(JSON.parse(JSON.stringify(product)));
                        setProductOverlayIndex(index);
                      }}
                    >
                      <idk-div
                        style={{
                          backgroundColor: `${layout?.productsSettings?.postOverlayColor}` || '#000000',
                          color: layout?.productsSettings?.postOverlayTextColor || '#ffffff',
                          backGroundOpacity: '50%',
                          width: '100%',
                          borderRadius: '4px',
                        }}
                        class="idk_prdct_overlay zid-relative zid-flex zid-bg-black zid-bg-opacity-70 zid-w-full zid-h-20 zid-cursor-pointer zid-items-center zid-p-1"
                        onClick={() => {
                          // if (row?.products?.length > 1) {
                          //   setSelectedProduct(product);
                          //   setProductOverlayIndex(index);
                          // }
                        }}
                      >
                        <LazyImage
                          onClick={(e) => {
                            const overlayClickAction = layout?.productsSettings?.productOverlayClickAction;

                            if (overlayClickAction === 'cart') {
                              clickMutate(row.id, {
                                event: 'add_to_cart',
                                price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                productId: product?.id_from_product ?? product?.id,
                              });
                              const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                              if (shopBtnFunctionality) {
                                try {
                                  const func = new Function('postData', 'productData', 'current', shopBtnFunctionality);
                                  func(row, product, btnOneRef.current[index]);
                                } catch (error) {
                                  console.error('Error executing shopBtnFunctionality', error);
                                }
                              } else {
                                showModal(row, 'slider');
                                setAlbumId(row.id);
                                setSelectedProduct(JSON.parse(JSON.stringify(product)));
                                setProductOverlayIndex(index);
                              }
                            } else {
                              e.stopPropagation();
                              window.open(
                                shopifyData
                                  ? `https://${window.location.host}/products/${product?.handle}`
                                  : `${product?.product_url}?utm_source=${
                                      layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                    }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                      layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                    }`,
                                '_blank',
                              );
                            }
                          }}
                          src={(() => {
                            const img =
                              product?.images?.[0]?.image_url?.replaceAll('resize/800x800', 'resize/64x64') ||
                              product?.images?.[0]?.replaceAll('resize/800x800', 'resize/64x64') ||
                              product?.image?.replaceAll?.('resize/800x800', 'resize/64x64');

                            return img ? `${img}${img.includes('?') ? '&' : '?'}width=72` : '';
                          })()}
                          className="zid-h-full zid-object-cover zid-bg-white zid-rounded"
                          style={{ maxWidth: '72px', maxHeight: '72px', flex: '0 0 72px' }}
                          loading="lazy"
                          alt={product?.title}
                        ></LazyImage>

                        <idk-div class="zid-flex zid-flex-col zid-gap-[6px] zid-justify-center zid-p-1 zid-h-20 zid-w-full zid-px-[6px]">
                          <idk-div class="zid-flex zid-gap-1 zid-justify-between">
                            <idk-span
                              class="zid-text-ellipsis zid-overflow-hidden zid-text-base zid-uppercase zid-product-title"
                              style={{
                                display: '-webkit-box',
                                WebkitLineClamp: '1',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                fontWeight: 600,
                                lineHeight: '18px',
                              }}
                              title={product?.title}
                              onClick={(e) => {
                                e.stopPropagation();
                                const overlayClickAction = layout?.productsSettings?.productOverlayClickAction;

                                if (overlayClickAction === 'cart') {
                                  clickMutate(row.id, {
                                    event: 'add_to_cart',
                                    price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                    productId: product?.id_from_product ?? product?.id,
                                  });
                                  const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                                  if (shopBtnFunctionality) {
                                    try {
                                      const func = new Function(
                                        'postData',
                                        'productData',
                                        'current',
                                        shopBtnFunctionality,
                                      );
                                      func(row, product, btnOneRef.current[index]);
                                    } catch (error) {
                                      console.error('Error executing shopBtnFunctionality', error);
                                    }
                                  } else {
                                    showModal(row, 'slider');
                                    setAlbumId(row.id);
                                    setSelectedProduct(JSON.parse(JSON.stringify(product)));
                                    setProductOverlayIndex(index);
                                  }
                                } else {
                                  clickMutate(row.id, {
                                    event: CLICK_EVENTS.PDP_REDIRECT,
                                    productId: product?.id_from_product ?? product?.id,
                                  });
                                  window.open(
                                    shopifyData
                                      ? addUTMToURL(`https://${window.location.host}/products/${product?.handle}`, {
                                          utm_source: layout?.gallerySettings?.utmSource,
                                          utm_medium: layout?.gallerySettings?.utmMedium,
                                          utm_campaign: layout?.gallerySettings?.utmCampaign,
                                        })
                                      : `${product?.product_url}?utm_source=${
                                          layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                        }&utm_medium=${
                                          layout?.gallerySettings?.utmMedium || 'AddToCart'
                                        }&utm_campaign=${
                                          layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                        }`,
                                    '_blank',
                                  );
                                }
                              }}
                            >
                              {product?.title}{' '}
                            </idk-span>
                            {layout?.popupSettings?.showPostDescription == false && (
                              <a
                                className=""
                                target="_blank"
                                href={addUTMToURL(
                                  shopifyData
                                    ? `https://${window.location.host}/products/${product?.handle}`
                                    : product?.product_url,
                                  {
                                    utm_source: layout?.gallerySettings?.utmSource,
                                    utm_medium: layout?.gallerySettings?.utmMedium,
                                    utm_campaign: layout?.gallerySettings?.utmCampaign,
                                  },
                                )}
                              >
                                <FiExternalLink color="#fff" fontSize={20} />
                              </a>
                            )}
                          </idk-div>
                          {layout?.productsSettings?.showProductRating && product?.productReview && (
                            <PostRating
                              rating={product?.productReview?.rating}
                              totalUsers={product?.productReview?.totalReview}
                              color={layout?.productsSettings?.productRatingStarColor}
                              url={
                                layout?.productsSettings?.productRatingUrl
                                  ? layout?.productsSettings?.productRatingUrl
                                  : shopifyData
                                  ? `https://${window.location.host}/products/${product?.handle}`
                                  : `${product?.product_url}?utm_source=${
                                      layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                    }&utm_medium=${layout?.gallerySettings?.utmMedium || 'StarRating'}&utm_campaign=${
                                      layout?.gallerySettings?.utmCampaign || 'ShoppableVideos'
                                    }`
                              }
                            />
                          )}
                          <idk-div class="zid-flex zid-justify-between zid-items-center">
                            <idk-div class="zid-flex zid-justify-between">
                              <idk-div class="zid-flex zid-gap-2">
                                {!layout?.productsSettings?.hideProductPrice && (
                                  <idk-div class="zid-font-bold">
                                    {isWooCommerceSite() &&
                                      !data.result.currency &&
                                      document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]
                                        ?.innerHTML}
                                    {shopifyData ? (
                                      <idk-div
                                        class={`${
                                          product?.variants?.[0]?.compare_at_price > product?.variants?.[0]?.price
                                            ? 'zid-discounted-price'
                                            : 'zid-regular-price'
                                        }`}
                                      >
                                        {layout?.productsSettings?.currencySymbol
                                          ? layout?.productsSettings?.currencySymbol
                                          : shopifyData?.currency?.active &&
                                            getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                        {calculatePrice(
                                          parseFloat(product?.variants?.[0]?.price) / 100,
                                          parseFloat(shopifyData?.currency?.rate),
                                        )}
                                      </idk-div>
                                    ) : (
                                      <PriceDisplay
                                        price={product?.variants?.[0]?.price}
                                        salePrice={product?.variants?.[0]?.salePrice}
                                        currency={data.result.currency}
                                        staticCurrency={layout?.productsSettings?.currencySymbol}
                                        discountPriceOnRight={layout?.productsSettings?.showDiscountPriceOnRight}
                                      />
                                    )}
                                    {shopifyData &&
                                      product?.variants?.[0]?.compare_at_price > product?.variants?.[0]?.price && (
                                        <idk-div class="zid-line-through zid-me-2 zid-text-red-400	zid-text-base zid-original-price">
                                          {layout?.productsSettings?.currencySymbol
                                            ? layout?.productsSettings?.currencySymbol
                                            : data.result.currency &&
                                              getCurrentSymbol(
                                                data.result.currency,
                                                navigator?.language || navigator['userLanguage'],
                                              )}
                                          {isWooCommerceSite() &&
                                            !data.result.currency &&
                                            document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]
                                              ?.innerHTML}
                                          {!layout?.productsSettings?.currencySymbol &&
                                            shopifyData?.currency?.active &&
                                            !data.result.currency &&
                                            getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                          {parseFloat(product?.variants?.[0]?.compare_at_price) / 100}
                                        </idk-div>
                                      )}
                                  </idk-div>
                                )}
                              </idk-div>
                            </idk-div>
                            <idk-div>
                              {layout?.productsSettings?.shopBtnPosition == 'absolute' && (
                                <button
                                  ref={btnOneRef.current[index]}
                                  onClick={() => {
                                    clickMutate(row.id, {
                                      event: 'add_to_cart',
                                      price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                      productId: product?.id_from_product ?? product?.id,
                                    });
                                    if (isShopify) {
                                      handleAddCart('1', product?.variants?.[0]?.id);
                                      e.stopPropagation();
                                      return;
                                    }
                                    const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                                    if (shopBtnFunctionality) {
                                      try {
                                        const func = new Function(
                                          'postData',
                                          'productData',
                                          'current',
                                          shopBtnFunctionality,
                                        );
                                        func(row, product, btnOneRef.current[index]);
                                      } catch (error) {
                                        console.error('Error executing shopBtnFunctionality', error);
                                      }
                                    } else {
                                      showModal(row, 'slider');
                                      setAlbumId(row.id);
                                      setSelectedProduct(JSON.parse(JSON.stringify(product)));
                                      setProductOverlayIndex(index);
                                      // if (row?.products?.length == 1) {
                                      //   window.open(
                                      //     shopifyData
                                      //       ? `https://${window.location.host}/products/${product?.handle}`
                                      //       : `${product?.product_url}?utm_source=${
                                      //           layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                      //         }&utm_medium=${
                                      //           layout?.gallerySettings?.utmMedium || 'AddToCart'
                                      //         }&utm_campaign=${
                                      //           layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                      //         }`,
                                      //     '_blank',
                                      //   );
                                      // }
                                    }
                                  }}
                                  className="zid-rounded zid-bg-[#f0f0f0] zid-text-black zid-text-base zid-font-bold zid-px-3 zid-py-1 zid-cart-btn zid-cursor-pointer"
                                  dangerouslySetInnerHTML={{
                                    __html: layout?.productsSettings?.shopBtnTextOverlay || 'Shop',
                                  }}
                                ></button>
                              )}
                            </idk-div>
                            {layout?.productsSettings?.showDiscountPercentage == true &&
                              getDiscountLabel(
                                product?.variants?.[0]?.compare_at_price,
                                product?.variants?.[0]?.price,
                              ) && (
                                <idk-div class="idk-discount-percentage">
                                  {getDiscountLabel(
                                    product?.variants?.[0]?.compare_at_price,
                                    product?.variants?.[0]?.price,
                                  )}
                                </idk-div>
                              )}
                          </idk-div>
                          {/* <button
                            ref={btnTwoRef.current[index]}
                            onClick={() => {
                              if (isOpen) {
                                clickMutate(row.id, {
                                  event: 'add_to_cart',
                                  price: product?.variants?.[0]?.salePrice,
                                  productId: product?.id_from_product,
                                });
                                setSelectedProduct(product);
                                setProductOverlayIndex(index);
                              } else {
                                const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                                if (shopBtnFunctionality) {
                                  try {
                                    const func = new Function(
                                      'postData',
                                      'productData',
                                      'current',
                                      shopBtnFunctionality,
                                    );
                                    func(row, product, btnTwoRef.current[index]);
                                  } catch (error) {
                                    console.error('Error executing shopBtnFunctionality', error);
                                  }
                                } else {
                                  window.open(
                                    shopifyData
                                      ? `https://${window.location.host}/products/${product?.handle}`
                                      : `${product?.product_url}?utm_source=${
                                          layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                        }&utm_medium=${
                                          layout?.gallerySettings?.utmMedium || 'AddToCart'
                                        }&utm_campaign=${
                                          layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                        }`,
                                    '_blank',
                                  );
                                }
                              }
                            }}
                            style={{ borderRadius: '0 0 5px 5px' }}
                            className="zid-cursor-pointer zid-h-14 zid-w-full zid-bg-[#f0f0f0] zid-text-black zid-text-base zid-font-bold zid-px-3 zid-py-1 zid-cart-btn"
                            dangerouslySetInnerHTML={{ __html: layout?.productsSettings?.shopBtnTextOverlay || 'Shop' }}
                          ></button> */}
                        </idk-div>
                      </idk-div>
                    </idk-div>
                  ) : (
                    <idk-div class="idk-product-overlay-container">
                      <idk-div
                        style={{
                          backgroundColor: `${layout?.productsSettings?.postOverlayColor}cc` || '#000000',
                          color: layout?.productsSettings?.postOverlayTextColor || '#ffffff',
                          backGroundOpacity: '50%',
                          width: '100%',
                        }}
                        class="idk-product-overlay zid-relative zid-flex zid-bg-black zid-bg-opacity-70 zid-text-white zid-w-full zid-h-[96px] zid-cursor-pointer zid-items-center zid-p-2"
                        onClick={() => {
                          // if (row?.products?.length > 1) {
                          //   setSelectedProduct(product);
                          //   setProductOverlayIndex(index);
                          // }
                        }}
                      >
                        <LazyImage
                          onClick={(e) => {
                            const overlayClickAction = layout?.productsSettings?.productOverlayClickAction;

                            if (overlayClickAction === 'cart') {
                              clickMutate(row.id, {
                                event: 'add_to_cart',
                                price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                productId: product?.id_from_product ?? product?.id,
                              });
                              const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                              if (shopBtnFunctionality) {
                                try {
                                  const func = new Function('postData', 'productData', 'current', shopBtnFunctionality);
                                  func(row, product, btnOneRef.current[index]);
                                } catch (error) {
                                  console.error('Error executing shopBtnFunctionality', error);
                                }
                              } else {
                                showModal(row, 'slider');
                                setAlbumId(row.id);
                                setSelectedProduct(JSON.parse(JSON.stringify(product)));
                                setProductOverlayIndex(index);
                              }
                            } else {
                              e.stopPropagation();
                              window.open(
                                shopifyData
                                  ? `https://${window.location.host}/products/${product?.handle}`
                                  : `${product?.product_url}?utm_source=${
                                      layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                    }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                      layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                    }`,
                                '_blank',
                              );
                            }
                          }}
                          src={(() => {
                            const img =
                              product?.images?.[0]?.image_url?.replaceAll('resize/800x800', 'resize/64x64') ||
                              product?.images?.[0]?.replaceAll('resize/800x800', 'resize/64x64') ||
                              product?.image?.replaceAll?.('resize/800x800', 'resize/64x64');

                            return img ? `${img}${img.includes('?') ? '&' : '?'}width=72` : '';
                          })()}
                          className="zid-h-full zid-object-contain zid-bg-white zid-rounded zid-img-product-modal"
                          style={{ maxWidth: '80px', maxHeight: '80px', flex: '0 0 80px' }}
                          loading="lazy"
                          alt={product?.title}
                        ></LazyImage>

                        <idk-div class="zid-flex zid-flex-col zid-justify-between zid-p-2 zid-h-[96px] zid-w-full">
                          <idk-div class="zid-flex zid-gap-1 zid-justify-between">
                            <idk-span
                              class="zid-productoverlay-title zid-text-ellipsis zid-overflow-hidden zid-text-base "
                              style={{
                                display: '-webkit-box',
                                WebkitLineClamp: '1',
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                fontWeight: 500,
                                lineHeight: '18px',
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                const overlayClickAction = layout?.productsSettings?.productOverlayClickAction;

                                if (overlayClickAction === 'cart') {
                                  clickMutate(row.id, {
                                    event: 'add_to_cart',
                                    price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                    productId: product?.id_from_product ?? product?.id,
                                  });
                                  const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                                  if (shopBtnFunctionality) {
                                    try {
                                      const func = new Function(
                                        'postData',
                                        'productData',
                                        'current',
                                        shopBtnFunctionality,
                                      );
                                      func(row, product, btnOneRef.current[index]);
                                    } catch (error) {
                                      console.error('Error executing shopBtnFunctionality', error);
                                    }
                                  } else {
                                    showModal(row, 'slider');
                                    setAlbumId(row.id);
                                    setSelectedProduct(JSON.parse(JSON.stringify(product)));
                                    setProductOverlayIndex(index);
                                  }
                                } else {
                                  clickMutate(row.id, {
                                    event: CLICK_EVENTS.PDP_REDIRECT,
                                    productId: product?.id_from_product ?? product?.id,
                                  });
                                  window.open(
                                    shopifyData
                                      ? `https://${window.location.host}/products/${product?.handle}`
                                      : `${product?.product_url}?utm_source=${
                                          layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                        }&utm_medium=${
                                          layout?.gallerySettings?.utmMedium || 'AddToCart'
                                        }&utm_campaign=${
                                          layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                        }`,
                                    '_blank',
                                  );
                                }
                              }}
                            >
                              {product?.title}{' '}
                            </idk-span>
                            {layout?.popupSettings?.showPostDescription == false && (
                              <a
                                className=""
                                target="_blank"
                                href={
                                  shopifyData
                                    ? `https://${window.location.host}/products/${product?.handle}`
                                    : product?.product_url
                                }
                              >
                                <FiExternalLink color="#fff" fontSize={20} />
                              </a>
                            )}
                          </idk-div>
                          {layout?.productsSettings?.showProductRating && product?.productReview && (
                            <PostRating
                              rating={product?.productReview?.rating}
                              totalUsers={product?.productReview?.totalReview}
                              color={layout?.productsSettings?.productRatingStarColor}
                              url={
                                layout?.productsSettings?.productRatingUrl
                                  ? layout?.productsSettings?.productRatingUrl
                                  : shopifyData
                                  ? `https://${window.location.host}/products/${product?.handle}`
                                  : `${product?.product_url}?utm_source=${
                                      layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                    }&utm_medium=${layout?.gallerySettings?.utmMedium || 'StarRating'}&utm_campaign=${
                                      layout?.gallerySettings?.utmCampaign || 'ShoppableVideos'
                                    }`
                              }
                            />
                          )}
                          <idk-div class="zid-flex zid-justify-between zid-items-center">
                            {!layout?.productsSettings?.hideProductPrice && (
                              <idk-div class="zid-flex zid-justify-between zid-items-center zid-gap-2">
                                <idk-div class="zid-flex zid-gap-2 zid-flex-wrap">
                                  <idk-div class="zid-font-bold">
                                    {isWooCommerceSite() &&
                                      !data.result.currency &&
                                      document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]
                                        ?.innerHTML}
                                    {shopifyData?.currency?.active &&
                                      getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                    {shopifyData ? (
                                      calculatePrice(
                                        parseFloat(product?.variants?.[0]?.price) / 100,
                                        parseFloat(shopifyData?.currency?.rate),
                                      )
                                    ) : (
                                      <PriceDisplay
                                        price={product?.variants?.[0]?.price}
                                        salePrice={product?.variants?.[0]?.salePrice}
                                        currency={data.result.currency}
                                      />
                                    )}
                                  </idk-div>
                                  {shopifyData &&
                                    product?.variants?.[0]?.compare_at_price > product?.variants?.[0]?.price && (
                                      <idk-div>
                                        <del className="zid-me-2 zid-text-red-400	zid-text-base">
                                          {data.result.currency &&
                                            getCurrentSymbol(
                                              data.result.currency,
                                              navigator?.language || navigator['userLanguage'],
                                            )}
                                          {isWooCommerceSite() &&
                                            !data.result.currency &&
                                            document?.getElementsByClassName('woocommerce-Price-currencySymbol')?.[0]
                                              ?.innerHTML}
                                          {shopifyData?.currency?.active &&
                                            !data.result.currency &&
                                            getCurrentSymbol(shopifyData?.currency?.active, shopifyData?.locale)}
                                          {parseFloat(product?.variants?.[0]?.compare_at_price) / 100}
                                        </del>
                                      </idk-div>
                                    )}
                                </idk-div>
                                {layout?.productsSettings?.showDiscountPercentage == true &&
                                  getDiscountLabel(
                                    product?.variants?.[0]?.compare_at_price,
                                    product?.variants?.[0]?.price,
                                  ) && (
                                    <idk-div class="idk-discount-percentage">
                                      {getDiscountLabel(
                                        product?.variants?.[0]?.compare_at_price,
                                        product?.variants?.[0]?.price,
                                      )}
                                    </idk-div>
                                  )}
                              </idk-div>
                            )}
                            <idk-div>
                              {layout?.productsSettings?.shopBtnPosition == 'absolute' && (
                                <button
                                  ref={btnOneRef.current[index]}
                                  onClick={() => {
                                    clickMutate(row.id, {
                                      event: 'add_to_cart',
                                      price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                      productId: product?.id_from_product ?? product?.id,
                                    });
                                    if (isShopify) {
                                      handleAddCart('1', product?.variants?.[0]?.id);
                                      e.stopPropagation();
                                      return;
                                    }
                                    const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                                    if (shopBtnFunctionality) {
                                      try {
                                        const func = new Function(
                                          'postData',
                                          'productData',
                                          'current',
                                          shopBtnFunctionality,
                                        );
                                        func(row, product, btnOneRef.current[index]);
                                      } catch (error) {
                                        console.error('Error executing shopBtnFunctionality', error);
                                      }
                                    } else {
                                      if (row?.products.length == 1) {
                                        window.open(
                                          shopifyData
                                            ? `https://${window.location.host}/products/${product?.handle}`
                                            : `${product?.product_url}?utm_source=${
                                                layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                              }&utm_medium=${
                                                layout?.gallerySettings?.utmMedium || 'AddToCart'
                                              }&utm_campaign=${
                                                layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                              }`,
                                          '_blank',
                                        );
                                      }
                                    }
                                  }}
                                  className="zid-rounded zid-bg-[#f0f0f0] zid-text-black zid-text-base zid-font-bold zid-px-3 zid-py-1 zIdkBtnPrdTagMain"
                                  dangerouslySetInnerHTML={{
                                    __html: layout?.productsSettings?.shopBtnTextOverlay || 'Shop',
                                  }}
                                ></button>
                              )}
                            </idk-div>
                          </idk-div>
                        </idk-div>
                      </idk-div>
                      {layout?.productsSettings?.shopBtnPosition == 'bottom' && (
                        <button
                          ref={btnTwoRef.current[index]}
                          onClick={() => {
                            if (isOpen) {
                              clickMutate(row.id, {
                                event: 'add_to_cart',
                                price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                productId: product?.id_from_product ?? product?.id,
                              });
                              setSelectedProduct(product);
                              setProductOverlayIndex(index);
                            } else {
                              const shopBtnFunctionality = layout?.productsSettings?.shopBtnFunctionality;
                              if (shopBtnFunctionality) {
                                clickMutate(row.id, {
                                  event: 'add_to_cart',
                                  price: product?.variants?.[0]?.salePrice ?? product?.variants?.[0]?.price / 100,
                                  productId: product?.id_from_product ?? product?.id,
                                });
                                try {
                                  const func = new Function('postData', 'productData', 'current', shopBtnFunctionality);
                                  func(row, product, btnTwoRef.current[index]);
                                } catch (error) {
                                  console.error('Error executing shopBtnFunctionality', error);
                                }
                              } else {
                                window.open(
                                  shopifyData
                                    ? `https://${window.location.host}/products/${product?.handle}`
                                    : `${product?.product_url}?utm_source=${
                                        layout?.gallerySettings?.utmSource || 'IdukkiUGC'
                                      }&utm_medium=${layout?.gallerySettings?.utmMedium || 'AddToCart'}&utm_campaign=${
                                        layout?.gallerySettings?.utmCampaign || 'ShoppableVideosHomepage'
                                      }`,
                                  '_blank',
                                );
                              }
                            }
                          }}
                          style={{ borderRadius: '0 0 5px 5px' }}
                          className="zid-cursor-pointer zid-h-14 zid-w-full zid-bg-[#f0f0f0] zid-text-black zid-text-base zid-font-bold zid-px-3 zid-py-1 zIdkBtnPrdTagMain"
                          dangerouslySetInnerHTML={{ __html: layout?.productsSettings?.shopBtnTextOverlay || 'Shop' }}
                        ></button>
                      )}
                    </idk-div>
                  )}
                </SwiperSlide>
              );
            })}
        </Swiper>
      </idk-div>
      {isOpen && (width <= 600 || data.result.layout.galleryView === 'frame') && (
        <SpecialProductMobileOverlay
          isOpen={isOpen}
          row={row}
          product={selectedProduct}
          setProduct={setSelectedProduct}
          shopifyData={shopifyData}
          albumData={albumData}
          activeIndex={activeIndex}
        />
      )}
      {/* {(width <= 600 || data.result.layout.galleryView === 'frame') && (
        <ProductMobileOverlay
          isOpen={isOpen}
          product={selectedProduct}
          setProduct={setSelectedProduct}
          shopifyData={shopifyData}
        />
      )} */}
    </React.Fragment>
  );
}
